module.exports = __webpack_public_path__ + "static/img/SCN.0e0a12e9.png";